const menuParams = {
  state: {
    menuParams: []
  },

  mutations: {
    SET_MENU_PARAMS: (state, menuParams) => {
      state.menuParams = menuParams
    }
  },

  actions: {
    SetMenuParams ({ commit }, menuParams) {
      commit('SET_MENU_PARAMS', menuParams)
    }
  }
}

export default menuParams
